import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/** Section carousel: horizontal snap scroll with peek + arrows (desktop), vertical page flow stays intact. */
export function HScroll({ title, action, children, itemClass = "w-[82vw] sm:w-[340px]", testid }) {
  const ref = useRef(null);
  const by = (dir) => ref.current?.scrollBy({ left: dir * (ref.current.clientWidth * 0.8), behavior: "smooth" });
  return (
    <section className="mt-8" data-testid={testid}>
      <div className="flex items-end justify-between gap-3 mb-3">
        {title && <h2 className="text-lg sm:text-xl font-bold tracking-tight text-[#0b0f1a]">{title}</h2>}
        <div className="flex items-center gap-2">
          {action}
          <div className="hidden sm:flex gap-1">
            <button type="button" onClick={() => by(-1)} aria-label="prev" data-testid={testid ? `${testid}-prev` : undefined} className="h-8 w-8 rounded-full border border-slate-200 bg-white inline-flex items-center justify-center hover:border-[#0b0f1a]"><ChevronLeft size={15} /></button>
            <button type="button" onClick={() => by(1)} aria-label="next" data-testid={testid ? `${testid}-next` : undefined} className="h-8 w-8 rounded-full bg-[#0b0f1a] text-white inline-flex items-center justify-center hover:bg-black"><ChevronRight size={15} /></button>
          </div>
        </div>
      </div>
      <div ref={ref} className="hscroll -mx-5 px-5 sm:mx-0 sm:px-0">
        {React.Children.map(children, (c) => c && <div className={itemClass}>{c}</div>)}
      </div>
    </section>
  );
}
